import {Box, Container, GlobalStyles, styled, Typography} from "@mui/material";
import LoadingSpinner from "../../components/loading/loadingSpinner";
import {SentimentDissatisfiedRounded} from "@mui/icons-material";
import {useEffect} from "react";
import {useUser} from "../../lib/hooks";
import {useNavigate} from "react-router-dom";
import Toasty from "../../theme/components/Toasty";
import {removeRefreshToken, removeToken, removeUserData} from "../../lib/services/jwtService";

export default function Logout() {

    const navigate = useNavigate();
    const user = useUser({redirectTo: "/"});
    const handleLogOut = async () => {
        if (!user) return;
        removeToken();
        removeRefreshToken();
        removeUserData();
        navigate('/', {replace: true});
        Toasty.warning('شما از حسابتان خارج شدید');
    }

    useEffect(() => {
        setTimeout(handleLogOut, 2500);
    }, []);

    if (user) return (
        <>
            <GlobalStyles styles={`body, html, main, #root {width: 100%;height: 100%;margin: 0;}`}/>
            <Box width={1} height={1}>
                <Container sx={{ height: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Wrapper>
                        <Box width={1} display="flex" alignItems="center" justifyContent="center"><SentimentDissatisfiedRounded color="info" sx={{ fontSize: {xs: "2.5rem", lg: "5rem"} }}/></Box>
                        <Box width={1} mt={1} display="flex" alignItems="center" justifyContent="center">
                            <Typography mr={1} fontSize={{xs: ".985rem", lg: "1.1rem"}}>شما در حال خروج از حسابتان هستید..</Typography>
                            <LoadingSpinner/>
                        </Box>
                    </Wrapper>
                </Container>
            </Box>
        </>
    )
}

const Wrapper = styled(Box)(({theme}) => ({
    width: "100%",
    display: "inline-flex",
    flexWrap: "wrap",
    padding: 24,
    color: "#424242 ",
    background: theme.palette.primary.light,
    borderRadius: 16,
    boxShadow: theme.shadows[25],
    [theme.breakpoints.up('lg')]: {
        width: "auto",
        padding: 64,
    },
}))